/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Chaitanya
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import Toast from 'react-native-toast-message';

import SociollaText from '@components/sociolla/SociollaText';
import ItemDetail from '@components/global/ItemDetail';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import * as Layout from '@components/screen/Layout';
import TaxesForm from '@components/setting/coa-tax/TaxesForm';
import ScrollContainer from '@components/global/ScrollContainer';

import { isWeb } from '@global/screens';
import { hasNoAccess } from '@global/helpers';
import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import { COA_TAX_SKP_FLOW_TYPE } from '@/constants';

const CoaTaxSettingDetailScreen = (props) => {
  const [detailData, setDetailData] = useState({});

  const getCoaTaxSettingsDetail = useApi(MsOrder.getCoaTaxSettingsDetail);

  const showEditButton = !hasNoAccess([
    'superadmin',
    'finance_head',
    'tax_support',
    'general',
  ]);

  const getDetail = async (id) => {
    const response = await getCoaTaxSettingsDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;
      if (result.market_type?.code == 'Select All') {
        result.market_type.code = 'All';
      }
      setDetailData(result);
    }
  };

  const goBack = () => {
    props.navigation.replace('CoaTaxSettingDetailScreen', {});
    props.navigation.navigate('CoaTaxSettingScreen');
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const formatSkpFlowValue = (val) => {
    const skpFlowMap = COA_TAX_SKP_FLOW_TYPE.reduce((acc, item) => {
      acc[item.value] = item;
      return acc;
    }, {});
    return skpFlowMap[val]?.label || 'Default';
  };

  return (
    <Layout.Container>
      {getCoaTaxSettingsDetail?.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : detailData && Object.keys(detailData).length ? (
        <>
          {isWeb ? (
            <Layout.Wrapper white={false}>
              <Layout.Back
                title="COA Tax Setting"
                onCallback={() => goBack()}
              />
            </Layout.Wrapper>
          ) : (
            false
          )}
          <Layout.Wrapper rounded>
            <ScrollContainer stickyHeaderIndices={isWeb ? [] : [0]}>
              <View style={styles.sectionWrapper}>
                {isWeb ? (
                  <View
                    style={[
                      styles.rowContainer,
                      {
                        position: 'relative',
                        zIndex: 1,
                        justifyContent: 'space-between',
                      },
                    ]}>
                    <SociollaText type="medium" style={{ fontSize: 20 }}>
                      COA Tax
                    </SociollaText>
                    {showEditButton ? (
                      <View style={{ position: 'relative' }}>
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{ width: 80, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Edit
                            </SociollaText>
                          }
                          onPress={() =>
                            props.navigation.navigate(
                              'CoaTaxSettingFormScreen',
                              {
                                id: detailData._id,
                                name: detailData.name ? detailData.name : '-',
                                titleScreen: detailData.cost_type
                                  ? detailData.cost_type
                                  : '-',
                              },
                            )
                          }
                        />
                      </View>
                    ) : (
                      false
                    )}
                  </View>
                ) : (
                  false
                )}
                <View
                  style={[
                    { maxWidth: isWeb ? 400 : '100%' },
                    isWeb ? { paddingVertical: 15 } : { paddingBottom: 20 },
                  ]}>
                  <ItemDetail
                    name="COA Number"
                    value={detailData.coa_number ? detailData.coa_number : '-'}
                  />
                  <ItemDetail
                    name="COA ID Cerebro"
                    value={
                      detailData.coa_cerebro_id
                        ? detailData.coa_cerebro_id
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="COA Type"
                    value={detailData.cost_type ? detailData.cost_type : '-'}
                  />
                  <ItemDetail
                    name="Description"
                    centered
                    value={
                      detailData.description ? detailData.description : '-'
                    }
                  />
                  <ItemDetail
                    name="Define SKP External Flow"
                    centered
                    value={formatSkpFlowValue(detailData?.skp_type_flow)}
                  />
                  <ItemDetail
                    name="Waiting For Sales Realization"
                    centered
                    value={
                      detailData.is_waiting_for_sales_realization ? 'Yes' : 'No'
                    }
                  />
                  <ItemDetail
                    name="Active/Inactive"
                    value={detailData.is_active ? 'Active' : 'Inactive'}
                  />
                </View>
                <TaxesForm
                  title={'Tax ID Corporate'}
                  values={detailData}
                  id={'tax_corporate'}
                  handleToggle={async (index, val) => {
                    const item = detailData.tax_corporate[index];
                    if (val == true && item.is_default == false) {
                      // Toggle on, set rest as false
                      const updatedData = {
                        ...detailData,
                        tax_corporate: detailData.tax_corporate.map((t, i) => {
                          if (i == index) {
                            t.is_default = val;
                          } else {
                            t.is_default = false;
                          }
                          return t;
                        }),
                      };
                      setDetailData(updatedData);
                      await MsOrder.updateCoaTaxSettings(
                        detailData._id,
                        updatedData,
                      );
                      Toast.show({
                        text1:
                          'Successfully update default for Tax ID Corporate',
                        type: 'success',
                      });
                    }
                  }}
                />
                <TaxesForm
                  title={'Tax ID Personal'}
                  values={detailData}
                  id={'tax_personal'}
                  handleToggle={async (index, val) => {
                    const item = detailData.tax_personal[index];
                    if (val == true && item.is_default == false) {
                      // Toggle on, set rest as false
                      const updatedData = {
                        ...detailData,
                        tax_personal: detailData.tax_personal.map((t, i) => {
                          if (i == index) {
                            t.is_default = val;
                          } else {
                            t.is_default = false;
                          }
                          return t;
                        }),
                      };
                      setDetailData(updatedData);
                      await MsOrder.updateCoaTaxSettings(
                        detailData._id,
                        updatedData,
                      );
                      Toast.show({
                        text1:
                          'Successfully update default for Tax ID Personal',
                        type: 'success',
                      });
                    }
                  }}
                />
                <TaxesForm
                  title={'VAT'}
                  values={detailData}
                  id={'vat'}
                  handleToggle={async (index, val) => {
                    const item = detailData.vat[index];
                    if (val == true && item.is_default == false) {
                      // Toggle on, set rest as false
                      const updatedData = {
                        ...detailData,
                        vat: detailData.vat.map((t, i) => {
                          if (i == index) {
                            t.is_default = val;
                          } else {
                            t.is_default = false;
                          }
                          return t;
                        }),
                      };
                      setDetailData(updatedData);
                      await MsOrder.updateCoaTaxSettings(
                        detailData._id,
                        updatedData,
                      );
                      Toast.show({
                        text1:
                          'Successfully update default for Tax ID Personal',
                        type: 'success',
                      });
                    }
                  }}
                />
              </View>
            </ScrollContainer>
          </Layout.Wrapper>
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
});

export default CoaTaxSettingDetailScreen;
